module.exports = (__webpack_require__(9))(3537);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-image-annotation/es/index.js from dll-reference vendor_cd7e7d937ca142ef7142
// module id = 206
// module chunks = 10